
import { CombeniaAttribute } from "./models/CombeniaAttribute";
import { CombeniaCriteria } from "./models/CombeniaCriteria";
import { CombeniaError } from "./models/CombeniaError";
import { CombeniaItem } from "./models/CombeniaItem";
import { HttpClient, HttpParams, HttpParameterCodec } from "@angular/common/http";
import { ICombeniaService } from "./interfaces/ICombeniaService";
import { Injectable } from "@angular/core";
import { env } from "../../environments/environment";
import { CombeniaSyncService } from "./CombeniaSyncService";
class CustomEncoder implements HttpParameterCodec {
	encodeKey(key: string): string {
	  return key;
	}
  
	encodeValue(value: string): string {
	  return value;
	}
  
	decodeKey(key: string): string {
	  return key;
	}
  
	decodeValue(value: string): string {
	  return value;
	}
  }
@Injectable()
export class CombeniaService {

	public constructor(
		private http: HttpClient,
		private sync: CombeniaSyncService,
	) {

	}

	getFormUrlEncoded(toConvert) {
		const formBody = [];
		for (const property in toConvert) {
			const encodedKey = encodeURIComponent(property);
			const encodedValue = encodeURIComponent(toConvert[property]);
			formBody.push(encodedKey + '=' + encodedValue);
		}
		return formBody.join('&');
	}

	public readEntity(entityName: string, filters) {
		return new Promise((resolve, reject) => {
			let token = this.sync.getToken();
			let url = env.baseUrl +  env.tenant + "/entityJson.app";
			let datas = {
				action: "read",
				token: token
			}
			datas[entityName + ".criteria"] = JSON.stringify(filters)
			let request = this.http
				.post(
					url,
					this.getFormUrlEncoded(datas),
					{ headers: { "Content-Type": "application/x-www-form-urlencoded" } }
				)
				.subscribe(
					success => {
						resolve(success);
					},
					error => {
						reject(error);
					},
					() => {
						request.unsubscribe();
					}
				);
		});

	}
	
	public storeDelete(entityName: string, payload) {
		return new Promise((resolve, reject) => {
			let token = this.sync.getToken();
			let url = env.baseUrl + env.tenant + "/entityJson.app";
			let datas = {
				action: "write",
				token: token
			}
			datas[entityName + ".criteria"] = JSON.stringify(payload)
			let request = this.http
				.post(
					url,
					this.getFormUrlEncoded(datas),
					{ headers: { "Content-Type": "application/x-www-form-urlencoded" } }
				)
				.subscribe(
					success => {
						resolve(success);
					},
					error => {
						reject(error);
					},
					() => {
						request.unsubscribe();
					}
				);
		});
	}
	public writeEntity(entityName: string, payload) {
		return new Promise((resolve, reject) => {
			let token = this.sync.getToken();
			let url = env.baseUrl + env.tenant + "/entityJson.app";
			let datas = {
				action: "write",
				token: token
			}
			datas[entityName + ".payload"] = JSON.stringify(payload)
			let request = this.http
				.post(
					url,
					this.getFormUrlEncoded(datas),
					{ headers: { "Content-Type": "application/x-www-form-urlencoded" } }
				)
				.subscribe(
					success => {
						resolve(success);
					},
					error => {
						reject(error);
					},
					() => {
						request.unsubscribe();
					}
				);
		});

	}
	//scrive più entità in transazione
	public writeEntities(entityMap: any) {
		return new Promise((resolve, reject) => {
			let token = this.sync.getToken();
			let url = env.baseUrl +  env.tenant + "/entityJson.app";
			let datas = {
				action: "write",
				token: token
			}
			for (let entityName in entityMap) {
				datas[entityName + ".payload"] = JSON.stringify(entityMap[entityName]);
			}
			let request = this.http
				.post(
					url,
					this.getFormUrlEncoded(datas),
					{ headers: { "Content-Type": "application/x-www-form-urlencoded" } }
				)
				.subscribe(
					success => {
						resolve(success);
					},
					error => {
						reject(error);
					},
					() => {
						request.unsubscribe();
					}
				);
		});

	}

	public getMediaByCriteria(criteria: CombeniaCriteria, offset:number, limit: number) {
		return new Promise((resolve,reject) => {
			let token = this.sync.getTokenUrlEncoded();
			let url = env.baseUrl + env.tenant +  '/json.app';
			let params = new HttpParams({encoder: new CustomEncoder()})
			.append('token', token)
			.append('action',"search")
			.append('parentId', "15")
			.append('path', "main/Media/")
			.append('offset', offset.toString())
			.append('limit', limit.toString());
			let data = {};
			if(criteria) {
				data = {
					criteria: JSON.stringify(criteria),
				}
			}
			let request = this.http
				.post(
					url,
					this.getFormUrlEncoded(data),
					{ headers: { "Accept": "*/*", "Content-Type": "application/x-www-form-urlencoded" } , params: params }
				)
				.subscribe(
					success => {
						resolve(success);
					},
					error => {
						reject(error);
					},
					() => {
						request.unsubscribe();
					}
				);
		});
	}

	public getItemsByCriteria(criteria: CombeniaCriteria) {
		return new Promise((resolve, reject) => {
			let token = this.sync.getToken();
			let url = env.baseUrl + env.tenant + "/json.app";
			let datas = {
				action: "search",
				limit: -1,
				offset: 0,
				criteria: JSON.stringify(criteria),
				token: token
			}
			let request = this.http
				.post(
					url,
					this.getFormUrlEncoded(datas),
					{ headers: { "Content-Type": "application/x-www-form-urlencoded" } }
				)
				.subscribe(
					success => {
						resolve(success["items"]);
					},
					error => {
						reject(error);
					},
					() => {
						request.unsubscribe();
					}
				);
		});

	}





}